import { Heading } from "@trueskin-web/components"

const PageHeader = ({ title, image, subline }) => (
  <div
    sx={{
      my: 5,
      display: "flex",
      columnGap: 2,
      alignItems: "flex-start",
      justifyContent: "space-between",
    }}
  >
    <div sx={{ flex: 3 }}>
      <Heading size="lg" sx={{ mb: 1, fontWeight: "bold" }}>
        {title}
      </Heading>
      {subline ? (
        <div
          sx={{
            fontSize: 1,
            color: "textLight",
          }}
        >
          {subline}
        </div>
      ) : null}
    </div>
    {image ? image : null}
  </div>
)

export default PageHeader
